// src/components/learning/exercisesData.js
// Données des exercices interactifs pour l'apprentissage de l'arabe

export const exercisesData = {
  // 🟢 NIVEAU DÉBUTANT
  beginner: {
    id: 'beginner',
    name: 'Débutant',
    nameAr: 'مبتدئ',
    icon: '🟢',
    color: '#10b981',
    description: 'Découvre les lettres arabes',
    exercises: [
      {
        id: 'listen-choose-letters',
        name: 'Écoute et Choisis',
        nameAr: 'استمع واختر',
        icon: '👂',
        description: 'Écoute la lettre et trouve-la',
        type: 'listen-choose',
        questions: [
          {
            id: 1,
            audio: 'alif',
            correct: 'أ',
            options: ['أ', 'ب', 'ت', 'ث'],
            hint: 'C\'est la première lettre de l\'alphabet'
          },
          {
            id: 2,
            audio: 'ba',
            correct: 'ب',
            options: ['ج', 'ب', 'د', 'ر'],
            hint: 'Elle a un point en dessous'
          },
          {
            id: 3,
            audio: 'ta',
            correct: 'ت',
            options: ['ث', 'ن', 'ت', 'ي'],
            hint: 'Elle a deux points au-dessus'
          },
          {
            id: 4,
            audio: 'tha',
            correct: 'ث',
            options: ['ت', 'ث', 'ب', 'ن'],
            hint: 'Elle a trois points au-dessus'
          },
          {
            id: 5,
            audio: 'jim',
            correct: 'ج',
            options: ['ح', 'خ', 'ج', 'ع'],
            hint: 'Elle a un point au milieu'
          },
          {
            id: 6,
            audio: 'ha',
            correct: 'ح',
            options: ['ج', 'ح', 'خ', 'هـ'],
            hint: 'Elle n\'a pas de point'
          },
          {
            id: 7,
            audio: 'kha',
            correct: 'خ',
            options: ['ح', 'ج', 'خ', 'غ'],
            hint: 'Elle a un point au-dessus'
          },
          {
            id: 8,
            audio: 'dal',
            correct: 'د',
            options: ['ذ', 'د', 'ر', 'ز'],
            hint: 'Elle ressemble à un petit bateau'
          },
          {
            id: 9,
            audio: 'shin',
            correct: 'ش',
            options: ['س', 'ش', 'ص', 'ض'],
            hint: 'Elle a trois dents et trois points'
          },
          {
            id: 10,
            audio: 'mim',
            correct: 'م',
            options: ['ن', 'ل', 'م', 'ك'],
            hint: 'Elle est ronde comme une boucle'
          }
        ]
      },
      {
        id: 'find-letter',
        name: 'Trouve la Lettre',
        nameAr: 'جد الحرف',
        icon: '👁️',
        description: 'Quel est le nom de cette lettre ?',
        type: 'find-letter',
        questions: [
          {
            id: 1,
            letter: 'أ',
            correct: 'Alif',
            options: ['Alif', 'Ba', 'Ta', 'Tha']
          },
          {
            id: 2,
            letter: 'ب',
            correct: 'Ba',
            options: ['Ta', 'Ba', 'Nun', 'Ya']
          },
          {
            id: 3,
            letter: 'س',
            correct: 'Sin',
            options: ['Shin', 'Sin', 'Sad', 'Dad']
          },
          {
            id: 4,
            letter: 'ع',
            correct: 'Ayn',
            options: ['Ghayn', 'Ha', 'Ayn', 'Kha']
          },
          {
            id: 5,
            letter: 'ك',
            correct: 'Kaf',
            options: ['Qaf', 'Kaf', 'Lam', 'Mim']
          },
          {
            id: 6,
            letter: 'و',
            correct: 'Waw',
            options: ['Ya', 'Ra', 'Waw', 'Nun']
          },
          {
            id: 7,
            letter: 'ي',
            correct: 'Ya',
            options: ['Ba', 'Nun', 'Ta', 'Ya']
          },
          {
            id: 8,
            letter: 'ن',
            correct: 'Nun',
            options: ['Ba', 'Ta', 'Nun', 'Ya']
          },
          {
            id: 9,
            letter: 'ل',
            correct: 'Lam',
            options: ['Alif', 'Lam', 'Kaf', 'Mim']
          },
          {
            id: 10,
            letter: 'ه',
            correct: 'Ha',
            options: ['Ha', 'Kha', 'Ayn', 'Ghayn']
          }
        ]
      }
    ]
  },

  // 🟡 NIVEAU INTERMÉDIAIRE
  intermediate: {
    id: 'intermediate',
    name: 'Intermédiaire',
    nameAr: 'متوسط',
    icon: '🟡',
    color: '#f59e0b',
    description: 'Apprends les formes et les mots',
    exercises: [
      {
        id: 'word-listen',
        name: 'Quel Mot ?',
        nameAr: 'أي كلمة؟',
        icon: '👂',
        description: 'Écoute le mot et trouve-le',
        type: 'listen-choose',
        questions: [
          {
            id: 1,
            audio: 'bayt',
            correct: 'بَيْت',
            options: ['بَيْت', 'بَاب', 'كِتَاب', 'قَلَم'],
            hint: 'C\'est là où tu habites',
            meaning: 'maison'
          },
          {
            id: 2,
            audio: 'kitab',
            correct: 'كِتَاب',
            options: ['قَلَم', 'كِتَاب', 'بَاب', 'وَرَقَة'],
            hint: 'Tu le lis',
            meaning: 'livre'
          },
          {
            id: 3,
            audio: 'shams',
            correct: 'شَمْس',
            options: ['قَمَر', 'نَجْم', 'شَمْس', 'سَمَاء'],
            hint: 'Elle brille le jour',
            meaning: 'soleil'
          },
          {
            id: 4,
            audio: 'qamar',
            correct: 'قَمَر',
            options: ['شَمْس', 'قَمَر', 'نَجْم', 'لَيْل'],
            hint: 'Il brille la nuit',
            meaning: 'lune'
          },
          {
            id: 5,
            audio: 'maa',
            correct: 'مَاء',
            options: ['حَلِيب', 'مَاء', 'عَصِير', 'شَاي'],
            hint: 'Tu la bois quand tu as soif',
            meaning: 'eau'
          },
          {
            id: 6,
            audio: 'samak',
            correct: 'سَمَك',
            options: ['دَجَاج', 'لَحْم', 'سَمَك', 'بَيْض'],
            hint: 'Il nage dans l\'eau',
            meaning: 'poisson'
          },
          {
            id: 7,
            audio: 'tuffah',
            correct: 'تُفَّاح',
            options: ['مَوْز', 'تُفَّاح', 'بُرْتُقَال', 'عِنَب'],
            hint: 'Fruit rouge ou vert',
            meaning: 'pomme'
          },
          {
            id: 8,
            audio: 'walad',
            correct: 'وَلَد',
            options: ['بِنْت', 'وَلَد', 'رَجُل', 'اِمْرَأَة'],
            hint: 'Un enfant masculin',
            meaning: 'garçon'
          }
        ]
      },
      {
        id: 'complete-word',
        name: 'Complète le Mot',
        nameAr: 'أكمل الكلمة',
        icon: '✍️',
        description: 'Quelle lettre manque ?',
        type: 'complete-word',
        questions: [
          {
            id: 1,
            word: 'بَـ_ـت',
            correct: 'ي',
            options: ['ي', 'و', 'ا', 'ن'],
            fullWord: 'بَيْت',
            meaning: 'maison'
          },
          {
            id: 2,
            word: 'كِتَا_',
            correct: 'ب',
            options: ['ت', 'ب', 'ن', 'م'],
            fullWord: 'كِتَاب',
            meaning: 'livre'
          },
          {
            id: 3,
            word: '_َمْس',
            correct: 'ش',
            options: ['س', 'ش', 'ص', 'ض'],
            fullWord: 'شَمْس',
            meaning: 'soleil'
          },
          {
            id: 4,
            word: 'مَدْرَ_َة',
            correct: 'س',
            options: ['ص', 'س', 'ش', 'ز'],
            fullWord: 'مَدْرَسَة',
            meaning: 'école'
          },
          {
            id: 5,
            word: 'قَلَ_',
            correct: 'م',
            options: ['ن', 'ل', 'م', 'ب'],
            fullWord: 'قَلَم',
            meaning: 'stylo'
          }
        ]
      }
    ]
  },

  // 🔴 NIVEAU AVANCÉ
  advanced: {
    id: 'advanced',
    name: 'Avancé',
    nameAr: 'متقدم',
    icon: '🔴',
    color: '#ef4444',
    description: 'Maîtrise l\'arabe',
    exercises: [
      {
        id: 'translate',
        name: 'Traduis',
        nameAr: 'ترجم',
        icon: '🔄',
        description: 'Trouve la traduction arabe',
        type: 'translate',
        questions: [
          {
            id: 1,
            french: 'maison',
            correct: 'بَيْت',
            options: ['بَيْت', 'بَاب', 'غُرْفَة', 'مَطْبَخ']
          },
          {
            id: 2,
            french: 'soleil',
            correct: 'شَمْس',
            options: ['قَمَر', 'شَمْس', 'نَجْم', 'سَمَاء']
          },
          {
            id: 3,
            french: 'eau',
            correct: 'مَاء',
            options: ['نَار', 'هَوَاء', 'مَاء', 'تُرَاب']
          },
          {
            id: 4,
            french: 'livre',
            correct: 'كِتَاب',
            options: ['دَفْتَر', 'كِتَاب', 'قَلَم', 'وَرَقَة']
          },
          {
            id: 5,
            french: 'père',
            correct: 'أَب',
            options: ['أُم', 'أَب', 'أَخ', 'أُخْت']
          },
          {
            id: 6,
            french: 'mère',
            correct: 'أُم',
            options: ['أَب', 'أُم', 'جَدَّة', 'خَالَة']
          },
          {
            id: 7,
            french: 'école',
            correct: 'مَدْرَسَة',
            options: ['جَامِعَة', 'مَكْتَبَة', 'مَدْرَسَة', 'صَف']
          },
          {
            id: 8,
            french: 'ami',
            correct: 'صَدِيق',
            options: ['صَدِيق', 'أَخ', 'جَار', 'زَمِيل']
          }
        ]
      },
      {
        id: 'speed-quiz',
        name: 'Quiz Chrono',
        nameAr: 'اختبار سريع',
        icon: '⏱️',
        description: 'Réponds vite ! 60 secondes',
        type: 'speed-quiz',
        timeLimit: 60,
        questions: [
          { id: 1, letter: 'أ', correct: 'Alif', options: ['Alif', 'Ba', 'Ta', 'Tha'] },
          { id: 2, letter: 'ب', correct: 'Ba', options: ['Alif', 'Ba', 'Ta', 'Tha'] },
          { id: 3, letter: 'ت', correct: 'Ta', options: ['Alif', 'Ba', 'Ta', 'Tha'] },
          { id: 4, letter: 'ث', correct: 'Tha', options: ['Alif', 'Ba', 'Ta', 'Tha'] },
          { id: 5, letter: 'ج', correct: 'Jim', options: ['Jim', 'Ha', 'Kha', 'Dal'] },
          { id: 6, letter: 'ح', correct: 'Ha', options: ['Jim', 'Ha', 'Kha', 'Dal'] },
          { id: 7, letter: 'خ', correct: 'Kha', options: ['Jim', 'Ha', 'Kha', 'Dal'] },
          { id: 8, letter: 'د', correct: 'Dal', options: ['Jim', 'Ha', 'Kha', 'Dal'] },
          { id: 9, letter: 'س', correct: 'Sin', options: ['Sin', 'Shin', 'Sad', 'Dad'] },
          { id: 10, letter: 'ش', correct: 'Shin', options: ['Sin', 'Shin', 'Sad', 'Dad'] },
          { id: 11, letter: 'ص', correct: 'Sad', options: ['Sin', 'Shin', 'Sad', 'Dad'] },
          { id: 12, letter: 'ض', correct: 'Dad', options: ['Sin', 'Shin', 'Sad', 'Dad'] },
          { id: 13, letter: 'ع', correct: 'Ayn', options: ['Ayn', 'Ghayn', 'Fa', 'Qaf'] },
          { id: 14, letter: 'غ', correct: 'Ghayn', options: ['Ayn', 'Ghayn', 'Fa', 'Qaf'] },
          { id: 15, letter: 'ف', correct: 'Fa', options: ['Ayn', 'Ghayn', 'Fa', 'Qaf'] },
          { id: 16, letter: 'ق', correct: 'Qaf', options: ['Ayn', 'Ghayn', 'Fa', 'Qaf'] },
          { id: 17, letter: 'ك', correct: 'Kaf', options: ['Kaf', 'Lam', 'Mim', 'Nun'] },
          { id: 18, letter: 'ل', correct: 'Lam', options: ['Kaf', 'Lam', 'Mim', 'Nun'] },
          { id: 19, letter: 'م', correct: 'Mim', options: ['Kaf', 'Lam', 'Mim', 'Nun'] },
          { id: 20, letter: 'ن', correct: 'Nun', options: ['Kaf', 'Lam', 'Mim', 'Nun'] }
        ]
      }
    ]
  }
};

// Messages d'encouragement
export const encouragements = {
  correct: [
    '🎉 Bravo !',
    '⭐ Excellent !',
    '👏 Très bien !',
    '🌟 Super !',
    '✨ Parfait !',
    '🏆 Champion !',
    '💪 Génial !',
    '🎯 Dans le mille !'
  ],
  wrong: [
    '💪 Réessaie !',
    '🤔 Presque...',
    '👀 Regarde bien !',
    '🔄 Encore une fois !',
    '💭 Réfléchis...',
    '🌱 Tu vas y arriver !'
  ],
  hint: [
    '💡 Indice : ',
    '🔍 Aide : ',
    '👁️ Regarde : '
  ]
};

// Seuils de score
export const scoreThresholds = {
  perfect: 100,    // 🏆 Trophée + feux d'artifice
  excellent: 90,   // 🎉 Confettis dorés
  good: 70,        // 🎊 Confettis
  passed: 50,      // ✅ Validé
  failed: 0        // 💪 Encouragement à réessayer
};

export default exercisesData;
